import React, { useEffect } from "react";

import { ManageEmailSubscriptionsPage } from "Components/ManageEmailSubscriptionsPage";
import { Redirect, Route, useHistory } from "react-router-dom";

import AcceptOrDeclineInvite from "../../components/AcceptOrDeclineInvite";
import Booking from "../../components/Booking";
import BookingMaintenance from "../../components/Booking/Maintenance";
import DashMetrics from "../../components/DashMetrics";
import { DiaryPage } from "../../modules/moving/pages/DiaryPage";
import RctAppLayout from "../../components/Generic/RctAppLayout";
import Notifications from "../../components/Notifications";
import OnBoarding from "../../components/OnBoarding";
import UserProfile from "../../components/Profile";
import { ShipmentMaintenancePage } from "../../components/Shipments/Maintenance";
import Unauthorized from "../../components/Unauthorized";
import VideoSurvey from "../../components/VideoSurvey";
import {
  OrdersMaintenanceWrapper,
  OrdersWrapper,
  QuickOrderWrapper,
} from "../../components/Wrappers/Orders";
import { ReportsMaintenanceWrapper, ReportsWrapper } from "../../components/Wrappers/Reports";
import { PRIVATE_ROUTES, PUBLIC_ROUTES, SESSION_TIME, SHIPEEZI_MOVING_DEV } from "../../constants";
import { useAppState } from "../../context/StateContext";
import useActionSyncUser from "../../hooks/useSyncUser";
import Movement from "../../pages/private/Moving/Movement";
import { MovementMaintenace } from "../../pages/private/Moving/Movement/Maintenance";
import Quote from "../../pages/private/Moving/Quote";
import QuoteMaintenance from "../../pages/private/Moving/Quote/Maintenance";
import { StorageAccounts } from "../../pages/private/Moving/Warehousing/StorageAccounts";
import { StorageAccountMaintenance } from "../../pages/private/Moving/Warehousing/StorageAccounts/Maintenance";
import { StorageBoxesAndUnitsPage } from "../../pages/private/Moving/Warehousing/StorageBoxesAndUnits";
import { TransshipmentsPage } from "../../pages/private/Moving/Warehousing/Transshipments";
import TransshipmentsMaintenance from "../../pages/private/Moving/Warehousing/Transshipments/Maintenance";
import Waybills from "../../pages/private/Moving/Waybills";
import { ShipmentMovingMaintenancePage } from "../../pages/private/Moving/Waybills/Maintenance";
import Billing from "../../pages/private/Shared/Billing";
import { NetworkPage } from "../../pages/private/Shared/Network";
import AccountMaintenance from "../../pages/private/Shared/Network/Account/Maintenance";
import CustomerMaintenance from "../../pages/private/Shared/Network/Customer/Maintenance";
import SupplierMaintenance from "../../pages/private/Shared/Network/Supplier/Maintenance";
// import NotificationCentre from "../../pages/private/Shared/NotificationCentre";
// modify is Admin in useActionSettings and remove notification centre repository since it is now templates.
import { SettingsScreen } from "../../pages/private/Shared/Settings";
import MembersMaintenance from "../../pages/private/Shared/Settings/People/Members/Member/Maintenance";
import UserMaintenance from "../../pages/private/Shared/Settings/People/Users/Maintenance";
import EquipmentCreation from "../../pages/private/Shared/Settings/Resources/FleetPage/CreateNewFleet";
import EquipmentEdit from "../../pages/private/Shared/Settings/Resources/FleetPage/Edit/EditPage";
import EditSubcontractor from "../../pages/private/Shared/Settings/Resources/Subcontractors/EditSubcontractor";
import CreateSubContractor from "../../pages/private/Shared/Settings/Resources/Subcontractors/SubcontractorsModal";
import ShipmentTracking from "../../pages/private/ShipmentTracking";
import ShipmentTrackingMaintenance from "../../pages/private/ShipmentTracking/Maintenance";
import Invoices from "../../pages/private/SupplyChain/Invoices";
import Container from "../../pages/private/SupplyChainPlus/Containers";
import Despatches from "../../pages/private/SupplyChainPlus/Despatches";
import DespatchMaintenance from "../../pages/private/SupplyChainPlus/Despatches/Maintenance";
import Products from "../../pages/private/SupplyChainPlus/Products";
import ProductsMaintenance from "../../pages/private/SupplyChainPlus/Products/Maintenance";
import { RoutePlannerPage } from "../../pages/private/SupplyChainPlus/RoutePlanner";
import Shipments from "../../pages/private/SupplyChainPlus/Shipments";
import ApproveCompany from "../../pages/public/ApproveCompany";
import SessionChecker from "../../pages/public/SignIn/SessionChecker";
import { CompanyProfile } from "../../util/enums";
import { checkResourceCan, FN_NAMES, hasPermission } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";
import { isMoving, isProductionShipeeziTestCompany } from "Util/validation";
import ExampleComponent from "../../pages/private/ExampleComponents";
import { DumontPanelProvider } from "../../context/DumontPanelContext";
import NewTemplatePage from "../../pages/private/Shared/Settings/CommunicationCentre/NewTemplate";
import { AgentCreateOrEditPage } from "../../modules/moving/external-agent/pages/AgentCreateOrEditPage";
import { AgentSelectCompanyModal } from "Modules/moving/external-agent/components/AgentSelectCompanyModal";
import FeatureLocked from "Components/FeatureLocked";
import CustomersPage from "../../pages/private/Shared/Network/CustomerPage";
import DumontSidebarPage from "@/pages/private/AskDumont/DumontSidebarPage";
import env from "../../util/env";

export const PrivateRoutes = () => {
  const history = useHistory();
  const { currentUser, setLoginTime, loginTime, pathPermissions, userPermissions } = useAppState();
  const { mutate: syncUser } = useActionSyncUser();
  const utcTime: string = localStorage.getItem(SESSION_TIME) ?? "";

  useEffect(() => {
    if (currentUser && !loginTime) setLoginTime();
    if (
      currentUser &&
      loginTime &&
      !Object.values(PUBLIC_ROUTES).includes(history.location.pathname)
    )
      syncUser();
  }, []);

  const FEATURE_LOCKED_ROUTES: Record<string, string> = {
    [PRIVATE_ROUTES.LEADS]: "Leads",
    [PRIVATE_ROUTES.PROPOSAL]: "Proposal",
    [PRIVATE_ROUTES.SUPPLIERS]: "Suppliers",
    [PRIVATE_ROUTES.INVOICING]: "Invoicing",
    [PRIVATE_ROUTES.CREDIT_NOTES]: "Credit Notes",
    [PRIVATE_ROUTES.EXPENSES]: "Expenses",
    [PRIVATE_ROUTES.CLAIMS]: "Claims",
    [PRIVATE_ROUTES.STORAGE_ACCOUNTS]: "Storage Account",
    [PRIVATE_ROUTES.FINANCE]: "Finance",
    [PRIVATE_ROUTES.BRANDING]: "Branding",
    [PRIVATE_ROUTES.LEGAL]: "Legal",
    [PRIVATE_ROUTES.INTEGRATIONS]: "Integrations",
    [PRIVATE_ROUTES.BOOKINGS]: "Bookings",
    [PRIVATE_ROUTES.DUMONT_AI]: "Dumont AI",
    [PRIVATE_ROUTES.SALES_APP]: "Sales App",
    [PRIVATE_ROUTES.BILLING]: "Billing",
    [PRIVATE_ROUTES.COMMUNICATION_CENTRE]: "Communication Centre",
  };

  const canShow = (route: string) =>
    pathPermissions?.find((p: { route: string; isShow: boolean }) => p?.route === route)?.isShow;

  const handleShipmentByProfile = (): JSX.Element => {
    if (currentUser?.company?.profile?.initials === CompanyProfile.MV) {
      return (
        <>
          <Route
            path={PRIVATE_ROUTES.SHIPMENTS}
            component={canShow(PRIVATE_ROUTES.SHIPMENTS) ? Waybills : Unauthorized}
          />
          {
            <Route
              path={PRIVATE_ROUTES.SHIPMENTS_MNT}
              exact
              component={
                checkResourceCan(
                  userPermissions ?? [],
                  ResourceName.SHIPMENTS,
                  ResourceCanEnum.EDIT
                ) &&
                (hasPermission(
                  userPermissions ?? [],
                  FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_PUBLISH
                ) ||
                  hasPermission(
                    userPermissions ?? [],
                    FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_DRAFT
                  ))
                  ? ShipmentMovingMaintenancePage
                  : Unauthorized
              }
            />
          }
          {
            <Route
              path={`${PRIVATE_ROUTES.SHIPMENTS_MNT}/:waybillId`}
              component={
                checkResourceCan(
                  userPermissions ?? [],
                  ResourceName.SHIPMENTS,
                  ResourceCanEnum.EDIT
                ) &&
                hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_OPERATIONS_SHIPMENTS_EDIT)
                  ? ShipmentMovingMaintenancePage
                  : Unauthorized
              }
            />
          }
        </>
      );
    }

    return (
      <>
        <Route path={PRIVATE_ROUTES.SHIPMENTS} component={Shipments} />
        <Route path={PRIVATE_ROUTES.SHIPMENTS_MNT} exact component={ShipmentMaintenancePage} />
        <Route
          path={`${PRIVATE_ROUTES.SHIPMENTS_MNT}/:shipmentId`}
          component={ShipmentMaintenancePage}
        />
      </>
    );
  };

  if (currentUser) {
    const layout = (
      <RctAppLayout>
        <SessionChecker
          utcTime={utcTime}
          autoTerminateSession={currentUser?.company?.companySecurity?.autoTerminateSession}
        />
        {handleShipmentByProfile()}
        {isMoving(currentUser.company) ? <AgentSelectCompanyModal /> : null}
        <Route path={PRIVATE_ROUTES.CONTAINERS} component={Container} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.OVERVIEW}
            component={canShow(PRIVATE_ROUTES.OVERVIEW) ? DashMetrics : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.OVERVIEW} component={DashMetrics} />
        )}
        <Route path={PRIVATE_ROUTES.ONBOARDING} component={OnBoarding} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.ORDERS}
            component={canShow(PRIVATE_ROUTES.ORDERS) ? OrdersWrapper : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.ORDERS} component={OrdersWrapper} />
        )}
        <Route path={PRIVATE_ROUTES.ORDERS_QUICK} exact component={QuickOrderWrapper} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.ORDERS_MNT}/`}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.ORDERS, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_OPERATIONS_ORDERS_ADD_NEW)
                ? OrdersMaintenanceWrapper
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.ORDERS_MNT}/`}
            exact
            component={OrdersMaintenanceWrapper}
          />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.ORDERS_MNT}/:id`}
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.ORDERS, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_OPERATIONS_ORDERS_EDIT)
                ? OrdersMaintenanceWrapper
                : Unauthorized
            }
          />
        ) : (
          <Route path={`${PRIVATE_ROUTES.ORDERS_MNT}/:id`} component={OrdersMaintenanceWrapper} />
        )}
        <Route
          path={PRIVATE_ROUTES.SHIPMENTS_TRACKING_MNT}
          exact
          component={ShipmentTrackingMaintenance}
        />
        <Route
          path={`${PRIVATE_ROUTES.SHIPMENTS_TRACKING_MNT}/:shipmentTrackingId`}
          exact
          component={ShipmentTrackingMaintenance}
        />
        <Route path={PRIVATE_ROUTES.DESPATCHES} component={Despatches} />
        <Route path={PRIVATE_ROUTES.DESPATCHES_MNT} component={DespatchMaintenance} />
        <Route path={PRIVATE_ROUTES.SHIPMENTS_TRACKING} component={ShipmentTracking} />
        <Route path={PRIVATE_ROUTES.PRODUCTS} component={Products} />
        <Route path={PRIVATE_ROUTES.PRODUCTS_MNT} component={ProductsMaintenance} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.ANALYTICS}
            component={canShow(PRIVATE_ROUTES.ANALYTICS) ? ReportsWrapper : Unauthorized}
            exact
          />
        ) : (
          <Route path={PRIVATE_ROUTES.ANALYTICS} component={ReportsWrapper} exact />
        )}
        {isMoving(currentUser?.company) ? (
          hasPermission(
            userPermissions ?? [],
            FN_NAMES.FUNCTION_REPORTS_GENERAL_EMAIL_SUBSCRIPTIONS
          ) && (
            <Route
              path={PRIVATE_ROUTES.MANAGE_EMAIL_SUBSCRIPTIONS}
              component={ManageEmailSubscriptionsPage}
              exact
            />
          )
        ) : (
          <Route
            path={PRIVATE_ROUTES.MANAGE_EMAIL_SUBSCRIPTIONS}
            component={ManageEmailSubscriptionsPage}
            exact
          />
        )}
        <Route path={PRIVATE_ROUTES.ANALYTICS_MNT} component={ReportsMaintenanceWrapper} />
        <Route path={PRIVATE_ROUTES.SUPPLIERS_MNT} component={SupplierMaintenance} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.SETTINGS}
            component={canShow(PRIVATE_ROUTES.SETTINGS) ? SettingsScreen : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.SETTINGS} component={SettingsScreen} />
        )}
        <Route path={PRIVATE_ROUTES.TEMPLATE_CREATE} exact component={NewTemplatePage} />
        <Route path={PRIVATE_ROUTES.USERS_MNT} component={UserMaintenance} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.EQUIPMENT_MNT}/:equipmentId`}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.RESOURCES,
                ResourceCanEnum.EDIT
              ) && hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_RESOURCES_EQUIPMENTS_EDIT)
                ? EquipmentEdit
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.EQUIPMENT_MNT}/:equipmentId`}
            exact
            component={EquipmentEdit}
          />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.EQUIPMENT_MNT}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.RESOURCES,
                ResourceCanEnum.EDIT
              ) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_RESOURCES_EQUIPMENTS_ADD_NEW)
                ? EquipmentCreation
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.EQUIPMENT_MNT} exact component={EquipmentCreation} />
        )}
        <Route path={PRIVATE_ROUTES.USERS_PEOPLE_MNT} exact component={UserMaintenance} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.SUBCONTRACTORS_MNT}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.RESOURCES,
                ResourceCanEnum.EDIT
              ) &&
              hasPermission(
                userPermissions ?? [],
                FN_NAMES.FUNCTION_RESOURCES_SUB_CONTRACTORS_ADD_NEW
              )
                ? CreateSubContractor
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.SUBCONTRACTORS_MNT} exact component={CreateSubContractor} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.SUBCONTRACTORS_MNT}/:subcontractorId`}
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.RESOURCES,
                ResourceCanEnum.EDIT
              ) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_RESOURCES_SUB_CONTRACTORS_EDIT)
                ? EditSubcontractor
                : Unauthorized
            }
            exact
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.SUBCONTRACTORS_MNT}/:subcontractorId`}
            component={EditSubcontractor}
            exact
          />
        )}
        <Route
          path={`${PRIVATE_ROUTES.USERS_PEOPLE_MNT}/:userId`}
          exact
          component={UserMaintenance}
        />
        <Route path={PRIVATE_ROUTES.PROFILE} component={UserProfile} />
        <Route path={`${PRIVATE_ROUTES.VIDEOCALL}/:taskId`} component={VideoSurvey} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.QUOTES}
            component={canShow(PRIVATE_ROUTES.QUOTES) ? Quote : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.QUOTES} component={Quote} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.QUOTES_MNT}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.QUOTE, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_SALES_QUOTE_ADD_NEW)
                ? QuoteMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.QUOTES_MNT} exact component={QuoteMaintenance} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.QUOTES_MNT}/:taskId`}
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.QUOTE, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_SALES_QUOTE_EDIT)
                ? QuoteMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route path={`${PRIVATE_ROUTES.QUOTES_MNT}/:taskId`} component={QuoteMaintenance} />
        )}
        <Route path={PRIVATE_ROUTES.SCHEDULE} component={DiaryPage} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.MOVING_DESPATCH}
            component={canShow(PRIVATE_ROUTES.MOVING_DESPATCH) ? DiaryPage : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.MOVING_DESPATCH} component={DiaryPage} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.NETWORK}
            component={canShow(PRIVATE_ROUTES.NETWORK) ? NetworkPage : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.NETWORK} component={NetworkPage} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.NETWORK_CUSTOMER_MNT}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.CUSTOMERS,
                ResourceCanEnum.EDIT
              ) && hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_NETWORK_CUSTOMERS_ADD_NEW)
                ? CustomerMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.NETWORK_CUSTOMER_MNT} exact component={CustomerMaintenance} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.NETWORK_CUSTOMER_MNT}/:customerId`}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.CUSTOMERS,
                ResourceCanEnum.EDIT
              ) && hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_NETWORK_CUSTOMERS_EDIT)
                ? CustomerMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.NETWORK_CUSTOMER_MNT}/:customerId`}
            exact
            component={CustomerMaintenance}
          />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.NETWORK_AGENT_MNT}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.AGENTS, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_NETWORK_AGENTS_ADD_NEW)
                ? AgentCreateOrEditPage
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.NETWORK_AGENT_MNT} exact component={AgentCreateOrEditPage} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.NETWORK_AGENT_MNT}/:agentId`}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.AGENTS, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_NETWORK_AGENTS_EDIT)
                ? AgentCreateOrEditPage
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.NETWORK_AGENT_MNT}/:agentId`}
            exact
            component={AgentCreateOrEditPage}
          />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.NETWORK_ACCOUNT_MNT}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.ACCOUNTS,
                ResourceCanEnum.EDIT
              ) && hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_NETWORK_ACCOUNTS_ADD_NEW)
                ? AccountMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.NETWORK_ACCOUNT_MNT} exact component={AccountMaintenance} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.NETWORK_ACCOUNT_MNT}/:accountId`}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.ACCOUNTS,
                ResourceCanEnum.EDIT
              ) && hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_NETWORK_ACCOUNTS_EDIT)
                ? AccountMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.NETWORK_ACCOUNT_MNT}/:accountId`}
            exact
            component={AccountMaintenance}
          />
        )}
        <Route path={PRIVATE_ROUTES.SETTINGS_APPROVE} component={ApproveCompany} />
        <Route path={PRIVATE_ROUTES.ACCEPT_INVITE} component={AcceptOrDeclineInvite} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.BOOKINGS}
            exact
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.BOOKINGS]} />
            )}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.BOOKINGS} exact component={Booking} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.BOOKINGS_MNT}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.BOOKING, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_OPERATIONS_BOOKING_ADD_NEW)
                ? BookingMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.BOOKINGS_MNT} exact component={BookingMaintenance} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.BOOKINGS_MNT}/:bookingId`}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.BOOKING, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_OPERATIONS_BOOKING_EDIT)
                ? BookingMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.BOOKINGS_MNT}/:bookingId`}
            exact
            component={BookingMaintenance}
          />
        )}
        <Route path={PRIVATE_ROUTES.NOTIFICATIONS} component={Notifications} />
        <Route path={PRIVATE_ROUTES.UNAUTHORIZED} component={Unauthorized} />
        <Route
          path={PRIVATE_ROUTES.BILLING}
          render={() => (
            <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.BILLING]} />
          )}
        />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.TRANSSHIPMENTS}
            component={canShow(PRIVATE_ROUTES.TRANSSHIPMENTS) ? TransshipmentsPage : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.TRANSSHIPMENTS} component={TransshipmentsPage} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.TRANSSHIPMENTS_MNT}
            exact
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.TRANSSHIPMENT,
                ResourceCanEnum.EDIT
              ) &&
              hasPermission(
                userPermissions ?? [],
                FN_NAMES.FUNCTION_WAREHOUSING_TRANSSHIPMENT_ADD_NEW
              )
                ? TransshipmentsMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={PRIVATE_ROUTES.TRANSSHIPMENTS_MNT}
            exact
            component={TransshipmentsMaintenance}
          />
        )}
        <Route
          path={`${PRIVATE_ROUTES.TRANSSHIPMENTS_MNT}/:transshipmentId`}
          exact
          component={TransshipmentsMaintenance}
        />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.MOVEMENT}
            component={canShow(PRIVATE_ROUTES.MOVEMENT) ? Movement : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.MOVEMENT} component={Movement} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.MOVEMENT_MNT}
            component={
              checkResourceCan(
                userPermissions ?? [],
                ResourceName.MOVEMENT,
                ResourceCanEnum.EDIT
              ) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_WAREHOUSING_MOVEMENT_ADD_NEW)
                ? MovementMaintenace
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.MOVEMENT_MNT} component={MovementMaintenace} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.INVOICES}
            component={canShow(PRIVATE_ROUTES.INVOICES) ? Invoices : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.INVOICES} component={Invoices} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.STORAGE_ACCOUNTS}
            render={() => (
              <FeatureLocked
                featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.STORAGE_ACCOUNTS]}
              />
            )}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.STORAGE_ACCOUNTS} component={StorageAccounts} />
        )}
        <Route path={PRIVATE_ROUTES.STORAGE_ACCOUNTS_MNT} component={StorageAccountMaintenance} />
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.STORAGE_BOXES_UNITS}
            component={
              canShow(PRIVATE_ROUTES.STORAGE_BOXES_UNITS) ? StorageBoxesAndUnitsPage : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.STORAGE_BOXES_UNITS} component={StorageBoxesAndUnitsPage} />
        )}
        <Route path={PRIVATE_ROUTES.ROUTE_PLANNER} component={RoutePlannerPage} />

        {isMoving(currentUser?.company) ? (
          <Route
            path={`${PRIVATE_ROUTES.MEMBERS_MNT}/:memberId`}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.PEOPLE, ResourceCanEnum.EDIT) &&
              hasPermission(userPermissions ?? [], FN_NAMES.FUNCTION_SETTINGS_PEOPLE_MEMBERS_EDIT)
                ? MembersMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route
            path={`${PRIVATE_ROUTES.MEMBERS_MNT}/:memberId`}
            exact
            component={MembersMaintenance}
          />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.MEMBERS_MNT}
            exact
            component={
              checkResourceCan(userPermissions ?? [], ResourceName.PEOPLE, ResourceCanEnum.EDIT) &&
              hasPermission(
                userPermissions ?? [],
                FN_NAMES.FUNCTION_SETTINGS_PEOPLE_MEMBERS_ADD_NEW
              )
                ? MembersMaintenance
                : Unauthorized
            }
          />
        ) : (
          <Route path={PRIVATE_ROUTES.LEADS} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.LEADS}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.LEADS]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.CUSTOMERS}
            component={canShow(PRIVATE_ROUTES.NETWORK) ? CustomersPage : Unauthorized}
          />
        ) : (
          <Route path={PRIVATE_ROUTES.CUSTOMERS} component={CustomersPage} />
        )}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.SUPPLIERS}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.SUPPLIERS]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.PROPOSAL}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.PROPOSAL]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.INVOICING}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.INVOICING]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.CREDIT_NOTES}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.CREDIT_NOTES]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.EXPENSES}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.EXPENSES]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.CLAIMS}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.CLAIMS]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.FINANCE}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.FINANCE]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.DUMONT_AI}
            render={() =>
              env.NODE_ENV === "production" &&
              !isProductionShipeeziTestCompany(currentUser?.company?.id ?? 0) ? (
                <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.DUMONT_AI]} />
              ) : (
                <DumontSidebarPage />
              )
            }
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.SALES_APP}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.SALES_APP]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.INTEGRATIONS}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.INTEGRATIONS]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.BRANDING}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.BRANDING]} />
            )}
          />
        ) : null}
        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.LEGAL}
            render={() => (
              <FeatureLocked featureLabel={FEATURE_LOCKED_ROUTES[PRIVATE_ROUTES.LEGAL]} />
            )}
          />
        ) : null}

        {isMoving(currentUser?.company) ? (
          <Route
            path={PRIVATE_ROUTES.COMMUNICATION_CENTRE}
            render={() => (
              <Redirect
                to={{
                  pathname: PRIVATE_ROUTES.SETTINGS,
                  state: { tabKey: "communicationcentre" },
                }}
              />
            )}
          />
        ) : null}

        {currentUser.email.includes("@shipeezi.com") ? (
          <Route path={PRIVATE_ROUTES.EXAMPLE_COMPONENTS} exact component={ExampleComponent} />
        ) : (
          <></>
        )}
      </RctAppLayout>
    );
    return <DumontPanelProvider>{layout}</DumontPanelProvider>;
  }

  return null;
};
